import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Routes = Loadable({
  loader: () => import("./routes/routes"),
  loading: TopBarProgress,
});

const HistoryRoutes = Loadable({
  loader: () => import("./routes/history/routes"),
  loading: TopBarProgress,
});

const HistoryDestinations = Loadable({
  loader: () => import("./routes/history/destinations"),
  loading: TopBarProgress,
});
const HistoryPickups = Loadable({
  loader: () => import("./routes/history/pickups"),
  loading: TopBarProgress,
});
const FlexPickup = Loadable({
  loader: () => import("./routes/flex/pickup"),
  loading: TopBarProgress,
});
const FlexTracking = Loadable({
  loader: () => import("./routes/flex/tracking"),
  loading: TopBarProgress,
});
const FlexDestinations = Loadable({
  loader: () => import("./routes/flex/destinations"),
  loading: TopBarProgress,
});
const Configurations = Loadable({
  loader: () => import("./routes/configurations"),
  loading: TopBarProgress,
});
const Parcels = Loadable({
  loader: () => import("views/private/routes/crm/routes/nationals/parcels"),
  loading: TopBarProgress,
});

const Lastmile = () => (
  <Switch>
    <Route path="/routes">
      <Routes />
    </Route>
    <Route path="/parcels">
      <Parcels />
    </Route>
    <Route path="/history/routes">
      <HistoryRoutes />
    </Route>
    <Route path="/flex/pickup">
      <FlexPickup />
    </Route>
    <Route path="/flex/tracking">
      <FlexTracking />
    </Route>
    <Route path="/flex/destinations">
      <FlexDestinations />
    </Route>
    <Route path="/configurations">
      <Configurations />
    </Route>
    <Route path="/history/destinations">
      <HistoryDestinations />
    </Route>
    <Route path="/history/pickups">
      <HistoryPickups />
    </Route>
    <Redirect to="/routes" />
  </Switch>
);

export default Lastmile;
